<template>
  <div>
    <v-container class="app-breadcrumbs-container">
      <v-breadcrumbs class="app-breadcrumbs" :items="breadcrumbs">
        <v-icon slot="divider">chevron_right</v-icon>
        <template slot="item" slot-scope="props">
          <router-link
            :to="props.item.to"
            :class="[
              props.item.disabled && 'v-breadcrumbs__item--disabled',
              'app-breadcrumbs__item'
            ]"
          >
            {{ props.item.text }}
          </router-link>
        </template>
      </v-breadcrumbs>
    </v-container>
    <v-container>
      <address-list />
    </v-container>
  </div>
</template>

<script>
import AddressList from "../../components/common/address-list";

export default {
  components: {
    AddressList
  },
  data() {
    return {};
  },
  computed: {
    breadcrumbs() {
      return [
        {
          to: { name: "account/info" },
          disabled: false,
          text: this.$t("breadcrumbs.account")
        },
        {
          to: { name: "address/list" },
          disabled: true,
          text: this.$t("breadcrumbs.address_list")
        }
      ];
    }
  }
};
</script>

<style scoped lang="sass" src="./list.sass"></style>
